export function flattenMenus(data) {
    let flatArray = [];
  
    if (!data || !Array.isArray(data)) {
      return flatArray; // Return an empty array if data is null, undefined, or not an array
    }
    data.forEach((page) => {
      if (!page) return; // Skip if page is null or undefined
      flatArray.push({
        id: page.id || null,
        slug: page.slug || "",
        title: page.title || "",
        description: page.description || "",
      });
  
      if (Array.isArray(page.sub_pages)) {
        page.sub_pages.forEach((subPage) => {
          if (!subPage) return; // Skip if subPage is null or undefined
  
          flatArray.push({
            id: subPage.id || null,
            slug: subPage.slug || "",
            title: subPage.title || "",
            description: subPage.description || "",
          });
        });
      }
    });
  
    return flatArray;
  }